import React, { useState } from "react";

export default function NotificacionesMasivas() {
  const [tipoDestinatario, setTipoDestinatario] = useState('TODOS'); 
  const [busquedaText, setBusquedaText] = useState("");
  const [empleadoBuscado, setEmpleadoBuscado] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState({ text: "", type: "" });

  const [formulario, setFormulario] = useState({
    destinatario: 'TODOS',
    titulo: '',
    mensaje: '',
    tipo: 'GLOBAL'
  });

  const handleBuscarEmpleado = async () => {
    if (!busquedaText.trim()) return;
    setBuscando(true);
    setEmpleadoBuscado(null);
    setMensaje({ text: "", type: "" });
    
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar?query=${busquedaText.trim()}`);
      const data = await res.json();
      
      const empleadoEncontradoObj = Array.isArray(data) ? data[0] : (data.usuario || data);

      if (empleadoEncontradoObj) {
        setEmpleadoBuscado(empleadoEncontradoObj);
        setFormulario({ ...formulario, destinatario: empleadoEncontradoObj.documento || busquedaText.trim() });
      } else {
        setMensaje({ text: "Empleado no encontrado en la base de datos.", type: "error" });
      }
    } catch (err) {
      setMensaje({ text: "Error de conexión al buscar empleado.", type: "error" });
    } finally {
      setBuscando(false);
    }
  };

  const handleEnviar = async (e) => {
    e.preventDefault();
    if (tipoDestinatario === 'INDIVIDUAL' && !empleadoBuscado) {
      setMensaje({ text: "Debes buscar y seleccionar un empleado primero.", type: "error" });
      return;
    }
    
    setEnviando(true);
    setMensaje({ text: "", type: "" });
    
    try {
      // AQUÍ CORREGIMOS LA RUTA (Añadimos /usuarios/ para unificarlo con tu backend)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/notificaciones/enviar-manual`, {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify(formulario)
      });
      const data = await res.json();
      
      if (data.success) {
        setMensaje({ text: "¡Notificación disparada con éxito! ", type: "success" });
        setFormulario({ destinatario: 'TODOS', titulo: '', mensaje: '', tipo: 'GLOBAL' });
        setEmpleadoBuscado(null);
        setBusquedaText("");
        setTipoDestinatario("TODOS");
      } else {
        setMensaje({ text: "Error al enviar: " + data.message, type: "error" });
      }
    } catch (error) {
      setMensaje({ text: "Error de conexión al enviar notificación.", type: "error" });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="w-full flex flex-col lg:flex-row gap-8 animate-fade-in">
      
      <div className="w-full lg:w-1/3 flex flex-col gap-6">
        <div>
          <h3 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-4">1. Destinatarios</h3>
          <div className="flex bg-slate-100/80 p-1.5 rounded-2xl border border-slate-200">
            <button 
              type="button" 
              onClick={() => { setTipoDestinatario('TODOS'); setFormulario({...formulario, destinatario: 'TODOS'}); setEmpleadoBuscado(null); }} 
              className={`flex-1 py-3 text-[11px] font-black uppercase tracking-widest rounded-xl transition-all duration-300 ${tipoDestinatario === 'TODOS' ? 'bg-white text-rose-600 shadow-sm border border-rose-100' : 'text-slate-500 hover:text-slate-700'}`}
            >
              🌍 A Todos
            </button>
            <button 
              type="button" 
              onClick={() => { setTipoDestinatario('INDIVIDUAL'); setFormulario({...formulario, destinatario: ''}); }} 
              className={`flex-1 py-3 text-[11px] font-black uppercase tracking-widest rounded-xl transition-all duration-300 ${tipoDestinatario === 'INDIVIDUAL' ? 'bg-white text-rose-600 shadow-sm border border-rose-100' : 'text-slate-500 hover:text-slate-700'}`}
            >
              👤 Individual
            </button>
          </div>
        </div>

        {tipoDestinatario === 'INDIVIDUAL' && (
          <div className="bg-slate-50/80 p-5 rounded-3xl border border-slate-200 animate-fade-in-up">
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Buscar por Cédula</label>
            <div className="flex gap-2">
              <input 
                type="text" 
                className="flex-1 px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-400 transition-all shadow-sm" 
                placeholder="Ej. 10697..." 
                value={busquedaText} 
                onChange={(e) => setBusquedaText(e.target.value)} 
              />
              <button 
                type="button" 
                onClick={handleBuscarEmpleado} 
                disabled={buscando} 
                className="px-5 py-3 bg-slate-800 hover:bg-slate-900 text-white text-xs font-bold rounded-xl transition-all shadow-md cursor-pointer disabled:opacity-50"
              >
                {buscando ? '...' : 'Buscar'}
              </button>
            </div>

            {empleadoBuscado && (
              <div className="mt-4 p-4 bg-white border border-rose-100 rounded-2xl flex items-center gap-4 shadow-sm animate-fade-in">
                <div className="w-12 h-12 bg-rose-50 rounded-full flex items-center justify-center text-rose-600 text-xl flex-shrink-0">👤</div>
                <div>
                  <p className="text-sm font-black text-slate-800 leading-tight">{empleadoBuscado.nombres} {empleadoBuscado.apellidos}</p>
                  {/* AQUÍ CORREGIMOS EL CAMPO DEL CARGO PARA QUE SÍ APAREZCA */}
                  <p className="text-[10px] text-slate-500 font-bold uppercase tracking-wider mt-1">
                    {empleadoBuscado.cargo_usuario || empleadoBuscado.empl_cargo || empleadoBuscado.cargo || 'Sin cargo'}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="w-full lg:w-2/3 bg-white/60 backdrop-blur-xl p-8 rounded-[32px] border border-white/80 shadow-xl">
        <h3 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-6">2. Redactar Notificación</h3>
        
        {mensaje.text && (
          <div className={`mb-6 p-4 rounded-2xl text-xs font-bold flex items-center gap-3 animate-fade-in-down ${mensaje.type === "success" ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-rose-50 text-rose-800 border border-rose-200"}`}>
            <span className="text-lg">{mensaje.type === "success" ? "✅" : "⚠️"}</span> {mensaje.text}
          </div>
        )}

        <form onSubmit={handleEnviar} className="space-y-5">
          <div>
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Título de la Alerta</label>
            <input type="text" required maxLength="50" className="w-full px-5 py-4 bg-white border border-slate-200 rounded-2xl text-slate-800 font-bold text-sm focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-400 shadow-sm transition-all" placeholder="Ej: Reunión de carácter urgente..." value={formulario.titulo} onChange={(e) => setFormulario({...formulario, titulo: e.target.value})} />
          </div>
          <div>
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Cuerpo del Mensaje</label>
            <textarea required rows="4" maxLength="200" className="w-full px-5 py-4 bg-white border border-slate-200 rounded-2xl text-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-400 shadow-sm transition-all resize-none" placeholder="Escribe los detalles de la notificación aquí..." value={formulario.mensaje} onChange={(e) => setFormulario({...formulario, mensaje: e.target.value})} />
            <p className="text-right text-[10px] text-slate-400 mt-2 font-bold">{formulario.mensaje.length}/200 caracteres</p>
          </div>
          <div className="flex justify-end pt-6 border-t border-slate-100">
            <button type="submit" disabled={enviando} className="btn-glow px-8 py-4 rounded-2xl bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white text-xs uppercase tracking-widest font-black shadow-lg shadow-rose-500/30 hover:shadow-rose-500/50 hover:-translate-y-1 transition-all duration-300 disabled:opacity-50 disabled:transform-none flex items-center gap-3 cursor-pointer">
              {enviando ? <><span className="animate-spin text-lg">⚙️</span> Enviando...</> : <><span className="text-lg"></span> Disparar Notificación Push</>}
            </button>
          </div>
        </form>
      </div>

    </div>
  );
}